import { motion } from "framer-motion";
import { FaEnvelope, FaLinkedin, FaMapMarkerAlt } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi";
import { useLanguage } from "../context/LanguageContext";
import translations from "../locales/translations";
import "./Contact.css";

const pageVariants = {
  initial: { opacity: 0, y: 30 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -30 },
};

const Contact = () => {
  const { lang } = useLanguage();
  const t = translations[lang];

  const contactInfo = [
    {
      icon: FaEnvelope,
      label: "Email",
      value: "benjamin@repellin.fr",
      href: "mailto:benjamin@repellin.fr",
    },
    {
      icon: FaMapMarkerAlt,
      label: lang === "fr" ? "Localisation" : "Location",
      value: t.contact.location,
    },
    {
      icon: HiSparkles,
      label: lang === "fr" ? "Disponibilité" : "Availability",
      value: t.contact.availability,
    },
  ];

  const socials = [
    {
      icon: FaLinkedin,
      href: "https://www.linkedin.com/in/benjamin-repellin-a4005429b/",
      label: "LinkedIn",
    },
  ];

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="in"
      exit="out"
      transition={{ duration: 0.45, ease: "easeOut" }}
    >
      <div className="contact-page">
        {/* Header */}
        <div className="contact-page__header">
          <div className="contact-page__header-bg" />
          <div className="contact-page__header-content">
            <motion.span
              className="section__tag"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              {lang === "fr" ? "Travaillons ensemble" : "Let's work together"}
            </motion.span>
            <motion.h1
              className="contact-page__title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              {t.contact.title}
            </motion.h1>
            <motion.p
              className="contact-page__subtitle"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.25 }}
            >
              {t.contact.subtitle}
            </motion.p>
          </div>
        </div>

        {/* Main content */}
        <div className="contact-page__body">
          <motion.div
            className="contact__info contact__info--centered"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="contact__info-title">{t.contact.info_title}</h2>
            <p className="contact__info-text">{t.contact.info_text}</p>

            <div className="contact__info-items">
              {contactInfo.map((item, i) => (
                <motion.div
                  key={i}
                  className="contact__info-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 + 0.2 }}
                >
                  <div className="contact__info-icon">
                    <item.icon size={18} />
                  </div>
                  <div>
                    <p className="contact__info-item-label">{item.label}</p>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="contact__info-item-value contact__info-item-value--link"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="contact__info-item-value">{item.value}</p>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="contact__socials">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__social"
                  aria-label={s.label}
                >
                  <s.icon size={20} />
                </a>
              ))}
            </div>
          </motion.div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer__container">
          <p>
            © {new Date().getFullYear()} Benjamin REPELLIN —{" "}
            {t.footer.made_with} React &nbsp;|&nbsp; {t.footer.rights}
          </p>
        </div>
      </footer>
    </motion.div>
  );
};

export default Contact;
